import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AllowancesService } from 'src/app/shared/services/allowances.service';

@Component({
  selector: 'app-add-allowance',
  templateUrl: './add-allowance.component.html',
  styleUrls: ['./add-allowance.component.scss']
})
export class AddAllowanceComponent implements OnInit {

  @Input() caseId : number;

  newAllowanceDetails = this.fb.group({
    description: [null, Validators.required],    
    amount: [null, Validators.required]
  }, { });

  constructor(
  private fb: UntypedFormBuilder,
  private allowancesService: AllowancesService,
  public activeModal: NgbActiveModal,
  ) { 
  }

  ngOnInit(): void {    
  }

  addAllowance() {
    var allowance = {
      description: this.newAllowanceDetails.controls['description'].value,
      amount: this.newAllowanceDetails.controls['amount'].value
    };
    this.allowancesService.addAllowance(this.caseId, allowance).subscribe((result) => {
      this.activeModal.close(true);
    });
  }

}
